import classes from "./TopBannersSection.module.less";

import { useTranslation } from "react-i18next";
import GlobalBanner from "~/Header/components/TopBannersSection/GlobalBanner/GlobalBanner";
import { SaleTag } from "../../../SalesCampaign/components/SaleTag/SaleTag";
import { Link } from "~/common/components/Link";
import { SALES_CAMPAIGN_PAGE } from "~/utils/url/staticUrls";
import { getRemainingTimeLabel, isValidPageForSalesBanner } from "~/Header/components/TopBannersSection/utils";
import { useSchaefflerTopBannerList } from "~/CMSComponents/components/SchaefflerTopBannerComponent";

import Parser from "html-react-parser";

import { isNonNull } from "~/utils/reducers";

export const TopBannersSection = () => {
  const { t } = useTranslation();
  const smartEditBanners = useSchaefflerTopBannerList();

  if (!isValidPageForSalesBanner(window.location.pathname)) {
    return null;
  }

  const activeCampaigns = window.SCHA.activeSalesCampaigns ?? [];

  const smartEditSalesCampaignCodes = smartEditBanners.map((banner) => banner.campaign?.code).filter(isNonNull);
  const campaignsNotInSmartEdit = activeCampaigns.filter(
    (campaign) => !smartEditSalesCampaignCodes.includes(campaign.code)
  );

  if (!smartEditBanners.length && !campaignsNotInSmartEdit.length) {
    // Nothing to show
    return null;
  }

  const smartEditBannerComponents = smartEditBanners.map((banner) => {
    const icon = banner.iconUrl ? <img className={classes.icon} src={banner.iconUrl} /> : undefined;
    const content: JSX.Element[] = banner.content ? (Parser(banner.content) as JSX.Element[]) : [];
    let remainingTimeLabel = "";
    if (banner.showRemainingTime && banner.campaign) {
      remainingTimeLabel = getRemainingTimeLabel(t, banner.campaign.endDate);
    }
    return (
      <GlobalBanner key={banner.uid} icon={icon}>
        <div className={classes.container}>
          {content} {remainingTimeLabel}
        </div>
      </GlobalBanner>
    );
  });

  let salesCampaignBanner = undefined;
  if (campaignsNotInSmartEdit.length) {
    const activeCampaign = campaignsNotInSmartEdit[0];
    salesCampaignBanner = (
      <GlobalBanner icon={<SaleTag size={32} />}>
        <div className={classes.container}>
          <Link className={classes.link} href={`${SALES_CAMPAIGN_PAGE}/${activeCampaign.urlMapping}`}>
            {activeCampaign.title}
          </Link>

          {getRemainingTimeLabel(t, activeCampaign.endDate)}
        </div>
      </GlobalBanner>
    );
  }

  return (
    <div>
      {smartEditBannerComponents}
      {salesCampaignBanner}
    </div>
  );
};
